import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'
import { useCallback, useEffect, useState } from 'react'
import {
  plannerProgramsSelectors,
  plannerProgramsThunks,
} from '@ucheba/store/planner/programs'
import { useDispatch, useSelector } from 'react-redux'
import { api } from '@ucheba/utils/helpers/api'
import { useDialog } from '@ucheba/ui/components/Dialog/bll'

interface IProps {
  programId: number
  institutionIds?: number[]
  excludeInstitutionIds?: number[]
  limit?: number
  parentId?: number
}

interface IUseSimilarPrograms {
  (props: IProps): {
    programs: IProgramId[] | null
    programIds?: number[] | null
  }
}

export const useSimilarPrograms: IUseSimilarPrograms = (props) => {
  const { programId, excludeInstitutionIds = [], institutionIds = [], limit } = props
  const dispatch = useDispatch()
  const [programs, setPrograms] = useState<IProgramId[] | null>(null)
  const programIds = useSelector(plannerProgramsSelectors.entityProgramsIds)

  const getPrograms = useCallback(async () => {
    const response = await api.get(`/programs/${programId}/similar`, {
      params: {
        limit,
        institutionIds,
        excludeInstitutionIds,
      },
    })

    setPrograms(response.data)
  }, [dispatch, programId, excludeInstitutionIds, institutionIds, limit])

  useEffect(() => {
    getPrograms()
  }, [])

  return {
    programs,
    programIds: programIds.entityIds,
  }
}
